import { getBrowserFingerprint } from '@patsnap-utils/browser-fingerprint';

let fingerprint = '';

export async function getFingerprint(): Promise<string> {
    if (!fingerprint) {
        fingerprint = await getBrowserFingerprint();
    }
    return fingerprint;
}
